// test/list.js
import { PageContainer } from '@ant-design/pro-layout'

function TestListPage() {
    return (
        <PageContainer
            header={{
                title: 'Add New Test',
            }}
        >
            sdfsdfdsfdf
        </PageContainer>
    )
}


export default TestListPage;